export const INSTALL_BANNER_HEIGHT = 64;

export const MOBILE_HEADER_HEIGHT = 50;

// The height of the header's sticky remainder once scrolled past (desktop
// only — mobile's equivalent is MOBILE_HEADER_HEIGHT above).
export const DESKTOP_STICKY_HEADER_HEIGHT = 64;
export const DESKTOP_ANCHOR_OFFSET_FROM_STICKY_HEADER =
  0.7 * DESKTOP_STICKY_HEADER_HEIGHT;

export const quickViewHeightCorrectionStyles = {
  quickViewHeightCorrection: '--quick-view-height-correction',
  heightCorrectionWhenInstallBannerIsOpen: `${INSTALL_BANNER_HEIGHT}px`,
  heightCorrectionWhenInstallBannerIsClosed: '0px',
};
